import React from 'react';
import { Modal, ModalContent, ModalFooter, ModalHeader, RegularButton } from 'fronton-react';
import { AdLabelModalProps } from '../types/ad-label-modal-props';
import { AdLabelLegalDataWrapperStyles, colorTextPrimary } from '../../banners-carousel/styles';
import { AdData } from '../../../common/components/ad-data';
import { cx, css } from 'linaria';

const modalStyles = css`
  & [data-testid='modal-overlay'] {
    z-index: 10000;
  }
`;

export function AdLabelModal(props: Readonly<AdLabelModalProps>) {
  const { ord, isModalOpen, close } = props;

  const textColor = isModalOpen && colorTextPrimary;

  return (
    <div className={modalStyles}>
      <Modal show={isModalOpen} onClose={close} size="s" variant="curtain" overlayClose={false}>
        <ModalHeader title="Реклама" />
        <ModalContent>
          <AdData
            className={cx(AdLabelLegalDataWrapperStyles, textColor)}
            {...{ ord }}
            variantEridColor="primary"
          />
        </ModalContent>
        <ModalFooter>
          <RegularButton size="l" variant="secondary" onClick={close}>
            Закрыть
          </RegularButton>
        </ModalFooter>
      </Modal>
    </div>
  );
}
